import { defineMessages } from 'react-intl';

export default defineMessages({
	detail: {
		id: 'components.walletPayment.walletTransactionCard.detail',
		defaultMessage: 'جزئیات',
	},
	modalTitle: {
		id: 'components.walletPayment.walletTransactionCard.modalTitle',
		defaultMessage: 'جزئیات تراکنش',
	},
});
